<template>
  <div v-if="!isMobile()">
    <div
      class="section section-arenalink"
      id="arenalink-section"
      data-background-color="white"
    >
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-9">
            <h3 data-aos="fade-up" class="title deco1">
              {{ $t(`arna title`) }}
            </h3>
          </div>
        </div>
        
        <div class="row">          
          <div
            class="text-center col-md-12 col-lg-9"
            style="margin: auto;"
          >
            <h5
              style="
                font-size: 18px;
                font-weight: 600;
                text-align: center;
                color: 0x000000;
              "
            >
              {{ $t(`arna desc`) }}
            </h5>
          </div>
        </div>
        <div class="video-container2" style="width: 77%; margin-left: 11.5%; height: 80%;">
              <iframe
                width="100%"
                height="100%"
                id="ytplayer"
                allowfullscreen
                frameborder="0"
                src="https://www.youtube.com/embed/_1tFqRFbbDI"
              ></iframe>
            </div>
        <div class="row" style="width: 80%; margin-left: 10%;">
          <div class="col-lg-6" style="margin-top: 25px;">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/img_game_15.png'" width="100%" />
              <h5
                class="arna-title"
                style="margin: -77px 10% 0; height: 40px;"
              >
                {{ $t(`arna detail title 1`) }}
              </h5>
              <h5
                class="arna-desc"
                style="text-align: center; margin: auto;"
              >
                {{ $t(`arna detail desc 1`) }}
              </h5>
            </div>
          </div>
          <div class="col-lg-6" style="margin-top: 25px;">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/img_game_16.png'" width="100%" />
              <div style="width: 90%; margin: auto">
                <h5
                  class="arna-title"
                  style="margin: -77px 10% 0; height: 40px"
                >
                  {{ $t(`arna detail title 2`) }}
                </h5>
              </div>
              <h5
                class="arna-desc"
                style="text-align: center; margin: auto;"
              >
                {{ $t(`arna detail desc 2`) }}
              </h5>
            </div>
          </div>
          <div class="col-lg-6" style="margin-top: 40px;">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/img_game_17.png'" width="100%" />
              <h5
                class="arna-title"
                style="margin: -77px 10% 0; height: 40px"
              >
                {{ $t(`arna detail title 3`) }}
              </h5>
              <h5
                class="arna-desc"
                style="text-align: center; margin: auto;"
              >
                {{ $t(`arna detail desc 3`) }}
              </h5>
            </div>
          </div>
          <div class="col-lg-6" style="margin-top: 40px;">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/img_game_18.png'" width="100%" />
              <h5
                class="arna-title"
                style="margin: -77px 10% 0; height: 40px"
              >
                {{ $t(`arna detail title 4`) }}
              </h5>
              <h5
                class="arna-desc"
                style="text-align: center; margin: auto;"
              >
                {{ $t(`arna detail desc 4`) }}
              </h5>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div
            style="
              margin: 40px auto;
              background-image: url(/img/btn_arna.png);
              background-size: 100%;
              background-repeat: no-repeat;
              width: 75.5%;
              height: 130px;
              cursor: pointer;
            "
            @click="goArena()"
          ></div>
        </div> -->
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="section-arenalink"
      id="arenalink-section"
      data-background-color="white"
    >
      <div class="container" style="width: 85%;">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-9">
            <h3 class="title-m deco1" style="margin-top: 20px;">
              {{ $t(`arna title`) }}
            </h3>
          </div>
        </div>
        <div class="row">
          <div
            class="text-center col-md-12 col-lg-9"
            style="margin: auto;"
          >
            <h5
              style="
                font-size: 14px;
                font-weight: 600;
                text-align: center;
                color: 0x000000;
              "
            >
              {{ $t(`arna desc`) }}
            </h5>
          </div>
        </div>
        <div class="video-container3" style="margin-left: -15px; margin-right: -15px;">
              <iframe
                width="100%"
                height="100%"
                id="ytplayer"
                allowfullscreen
                frameborder="0"
                src="https://www.youtube.com/embed/_1tFqRFbbDI"
              ></iframe>
            </div>
        <div class="row" style="margin-bottom: 30px;">
          <div class="col-sg-12" style="margin-top: 25px;">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/img_game_15.png'" width="100%" />
              <h5
                class="arna-title-m"
                style="margin: -58px 10% 0; height: 30px;"
              >
                {{ $t(`arna detail title 1`) }}
              </h5>
              <h5
                class="arna-desc-m"
                style="text-align: center; margin: auto;"
              >
                {{ $t(`arna detail desc 1`) }}
              </h5>
            </div>
          </div>
          <div class="col-sg-12" style="margin-top: 25px;">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/img_game_16.png'" width="100%" />
              <div style="width: 90%; margin: auto">
                <h5
                  class="arna-title-m"
                  style="margin: -58px 10% 0; height: 30px;"
                >
                  {{ $t(`arna detail title 2`) }}
                </h5>
              </div>
              <h5
                class="arna-desc-m"
                style="text-align: center; margin: auto;"
              >
                {{ $t(`arna detail desc 2`) }}
              </h5>
            </div>
          </div>
          <div class="col-sg-12" style="margin-top: 25px;">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/img_game_17.png'" width="100%" />
              <h5
                class="arna-title-m"
                style="margin: -58px 10% 0; height: 30px;"
              >
                {{ $t(`arna detail title 3`) }}
              </h5>
              <h5
                class="arna-desc-m"
                style="text-align: center; margin: auto;"
              >
                {{ $t(`arna detail desc 3`) }}
              </h5>
            </div>
          </div>
          <div class="col-sg-12" style="margin-top: 25px;">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/img_game_18.png'" width="100%" />
              <h5
                class="arna-title-m"
                style="margin: -58px 10% 0; height: 30px;"
              >
                {{ $t(`arna detail title 4`) }}
              </h5>
              <h5
                class="arna-desc-m"
                style="text-align: center; margin: auto;"
              >
                {{ $t(`arna detail desc 4`) }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    goArena() {
      let url = "//play.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
  },
};
</script>
<style></style>
